//<!----- Product Ingredients Section Popup Code Start -----> //

document.addEventListener('DOMContentLoaded', () => {
    let popupButton = document.querySelector('.ingredients__footer .ingredients__button');
    let popupModel = document.querySelector('.product-ingredients .ingredients__footer base-modal.modal');
    let popupClose = document.querySelector('.product-ingredients .ingredients__footer .modal__close-button');
    let bodyElement = document.querySelector('body');

    if (popupButton && popupModel && popupClose) {
      popupButton.addEventListener('click', ()=> {
          popupModel.classList.add('is-open');
          bodyElement.classList.add('overflow-none');
      });
      popupClose.addEventListener('click', ()=> {
          popupModel.classList.remove('is-open');
          bodyElement.classList.remove('overflow-none');
      });
    }
});

//<!----- Product Ingredients Section Popup Code End -----> //

//<!----- Cart Button Disabled On Window Load Code Start -----> //

document.addEventListener("DOMContentLoaded", function() {
  const cartButton = document.querySelector('.header__cart-link');

  if (cartButton) {
    cartButton.style.pointerEvents = 'none';
    cartButton.style.opacity = '0.5';
    cartButton.setAttribute('aria-disabled', 'true');
  }

  window.addEventListener('load', function() {
    setTimeout(() => {
      if (cartButton) {
        cartButton.style.pointerEvents = '';
        cartButton.style.opacity = '';
        cartButton.removeAttribute('aria-disabled');
      }
    }, 1000);
  });
});

//<!----- Cart Button Disabled On Window Load Code End -----> //

//<!----- Cart Drawer Free Gift Button Disabled Code Start -----> //

(function () {
  if (window._rebuy_readd_script_installed) return;
  window._rebuy_readd_script_installed = true;

  let disableTimer = null;
  let buttonsDisabledUntil = 0;

  // Disable all buttons for given duration
  function disableAllButtons(duration) {
    const now = Date.now();
    buttonsDisabledUntil = now + duration;

    setDisabledState(true);

    clearTimeout(disableTimer);
    disableTimer = setTimeout(() => {
      buttonsDisabledUntil = 0;
      setDisabledState(false);
    }, duration);
  }

  // Set disabled/enabled state to all matching buttons
  function setDisabledState(isDisabled) {
    const buttons = document.querySelectorAll(
      '.rebuy-cart__progress-gift-remove, .rebuy-cart__progress-gift-variant-readd'
    );

    buttons.forEach(btn => {
      btn.disabled = isDisabled;
      btn.style.pointerEvents = isDisabled ? 'none' : '';
      btn.style.opacity = isDisabled ? '0.5' : '';
    });
  }

  // Attach click listeners to current buttons
  function attachHandlers() {
    const allButtons = document.querySelectorAll(
      '.rebuy-cart__progress-gift-remove, .rebuy-cart__progress-gift-variant-readd'
    );

    allButtons.forEach(btn => {
      if (!btn.dataset.listenerAdded) {
        btn.addEventListener('click', () => disableAllButtons(5000));
        btn.dataset.listenerAdded = "true";
      }
    });

    // if we’re currently in the disabled window, make sure new buttons also appear disabled
    if (Date.now() < buttonsDisabledUntil) {
      setDisabledState(true);
    }
  }

  // Initial attach
  attachHandlers();

  // Observe DOM mutations from Rebuy re-render
  const observer = new MutationObserver(() => {
    clearTimeout(observer._debounceTimer);
    observer._debounceTimer = setTimeout(() => {
      attachHandlers();

      // If timer is still running, keep new buttons disabled
      if (Date.now() < buttonsDisabledUntil) {
        setDisabledState(true);
      }
    }, 150);
  });

  const cartDrawer = document.querySelector('#cart-drawer');
  if (cartDrawer) {
    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }
})();

//<!----- Cart Drawer Free Gift Button Disabled Code End -----> //

//<!----- Redirect From Cart Page To Home Page When Empty Code Start -----> //

// Commented out — was redirecting /cart to homepage, blocking cart page access
// if (window.location.pathname === "/cart") {
//   fetch("/cart.js")
//     .then(function(res) { return res.json(); })
//     .then(function(cart) {
//       if (cart.item_count === 0) {
//         window.location.href = "/";
//       }
//     });
// }

//<!----- Redirect From Cart Page To Home Page When Empty Code End -----> //

//<!----- Cart Drawer Checkout Button Disabled On Remove Button & Quantity Buttons Click Code Start -----> //

document.addEventListener("DOMContentLoaded", () => {
  const cartContainer = document.body;

  function temporarilyDisableCheckout() {
    const checkoutButton = document.querySelector('.rebuy-cart__checkout-button');
    if (!checkoutButton) return;

    checkoutButton.setAttribute('disabled', true);
    checkoutButton.classList.add('disabled');

    setTimeout(() => {
      checkoutButton.removeAttribute('disabled');
      checkoutButton.classList.remove('disabled');
    }, 4000);
  }

  cartContainer.addEventListener("click", function(event) {

    if (event.target.closest(".rebuy-cart__flyout-item-remove")) {
      temporarilyDisableCheckout();
    }

    if (event.target.closest(".rebuy-cart__flyout-item-quantity-widget-button")) {
      temporarilyDisableCheckout();
    }

  });
});

//<!----- Cart Drawer Checkout Button Disabled On Remove Button & Quantity Buttons Click Code End -----> //